import axios from "axios";

export const userAuth = ({ email, password }) => {
  return new Promise((resolve, reject) => {
    try {
      const user = axios.post(
        "https://crm-beckend-amrinder-org.onrender.com/v1/user/login",
        {
          email,
          password,
        }
      );

      resolve(user);
    } catch (error) {
      reject(error);
    }
  });
};

export const getuser = () => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log(sessionStorage.getItem("accessJwt"));
      const user = await axios.get(
        "https://crm-beckend-amrinder-org.onrender.com/v1/user/getuser",
        {
          headers: {
            authorization: sessionStorage.getItem("accessJwt"),
          },
        }
      );

      console.log(user, "ma he ha user");
      resolve(user);
    } catch (error) {
      reject(error);
    }
  });
};

export const getSingleTicket = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = "https://crm-beckend-amrinder-org.onrender.com/v1/ticket/";
      const ticket = await axios.get(url + id, {
        headers: {
          authorization: sessionStorage.getItem("accessJwt"),
        },
      });

      resolve(ticket);
    } catch (error) {
      reject(error);
    }
  });
};

export const sendreply = (id, msgobj) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = "https://crm-beckend-amrinder-org.onrender.com/v1/ticket/";

      const res = await axios.put(url + id, msgobj, {
        headers: {
          authorization: sessionStorage.getItem("accessJwt"),
        },
      });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const createNewTicket = (senderobject) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = "https://crm-beckend-amrinder-org.onrender.com/v1/ticket";

      const ticket = await axios.post(url, senderobject, {
        headers: {
          authorization: sessionStorage.getItem("accessJwt"),
        },
      });
      console.log(ticket);
      resolve(ticket);
    } catch (error) {
      reject(error);
    }
  });
};

export const closeTicket = (_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url =
        "https://crm-beckend-amrinder-org.onrender.com/v1/ticket/close-ticket/";
      const res = await axios.patch(url + _id, {
        headers: {
          authorization: sessionStorage.getItem("accessJwt"),
        },
      });
      console.log("Amrinder clkosse ", res);
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const checkuserexits = (email) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url =
        "https://crm-beckend-amrinder-org.onrender.com/v1/user/password-reset";
      const res = await axios.post(url, { email });
      resolve(res);
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};

export const resetpass = ({ email, pin, newpassword }) => {
  return new Promise(async (resolve, reject) => {
    console.log(email, pin, newpassword);
    try {
      const url =
        "https://crm-beckend-amrinder-org.onrender.com/v1/user/password-reset";
      const res = await axios.patch(url, { email, pin, newpassword });
      resolve(res);
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};
